import styled from 'styled-components/native'

export const Container = styled.View.attrs(({ isModal }) => ({
  justifyContent: isModal ? 'flex-start' : 'center',
}))`
  align-items: ${props => (props.isDoneSlide ? 'center' : 'flex-start')};
  flex: 1;
  justify-content: ${props => props.justifyContent};
`
